export enum NotificationOption {
    None = 0,
    OnPublishDate = 1,
    DaysInAdvance = 2
}
